{
	"cover": "{{title}} cover"
}
